import RouteUtils from '~/core/utils/RouteUtils';
import {policyPaths} from '~/paths';
import {OKTA_ROLE} from '~/config';

const routes = [
	{
		path: policyPaths.policyHindsightBusinessDetailsPagePattern,
		title: 'Business Details',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyHindsightBusinessDetailsPage');
		}),
	},
	{
		path: policyPaths.policyHindsightWagesPagePattern,
		title: 'Business Wages',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyHindsightWagesPage');
		}),
	},
	{
		path: policyPaths.policyHindsightPremiumPagePattern,
		title: 'Policy Premium',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyHindsightPremiumPage');
		}),
	},
	{
		path: policyPaths.policyHindsightConfirmationPagePattern,
		title: 'Policy Confirmation',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyHindsightConfirmationPage');
		}),
	},
];

export default routes;
